import React, { useEffect, useRef, useState } from 'react';
import { PieChart, Pie, Cell, Label } from 'recharts';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import AutomService from '../../../../services/AutomService/AutomService';
import OperationService from '../../../../services/OperationService/OperationService';
import { personalizationState} from '../../../../recoil-store/recoil-state';
import { useRecoilValue } from 'recoil';

const ttCOLORS = ['#002742', '#b6b6b6'];
const rrCOLORS = ['#02b554', '#d75e5e'];
/**
 * @Description This function lets you return Dashboard component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Overview (props) {
    const { t } = useTranslation();
    const label = 'CONTENT.DASHBOARD.';
    // Initial state
    const custom = useRef();
    const [dateRange, setDateRange] = useState([new Date(), new Date()]);
    const [state, setState] = useState({
        robotReport: [{ value: 0 }, { value: 1 }],
        totalTime: [{ value: 0 }, { value: 1 }],
        completed: 0, avgTime: 0, total: 0,
        count: 0, rank: []
    });
    const personalization = useRecoilValue(personalizationState);

    // Fetch data on start
    useEffect(() => {
        let today = new Date();
        let week = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
        fetchData(week.toISOString(), today.toISOString());
    }, []);

    // Fetch Overview data
    const fetchData = async (startDate = '', endDate = '') => {
        let robotReport = state.robotReport, totalTime = state.totalTime;
        let completed = 0, avgTime = 0, total = 0, count = 0, rank = [];
        // Fetch Operation Percentage data
        let res = await OperationService.getOperationPercentage(startDate, endDate);
        if (res?.status) {
            let completePercentage = parseInt(res.data?.completePercentage, 10);
            let failedPercentage = parseInt(res.data?.failedPercentage, 10);
            if (completePercentage === 0 && failedPercentage === 0) { failedPercentage = 1; }
            robotReport = [{ value: completePercentage }, { value: failedPercentage }];
        }

        // Fetch Operation Total Time data
        res = await OperationService.getOperationTotalTime(startDate, endDate);
        if (res?.status) {
            let totalTimeElapsed = parseFloat(res.data);//parseInt(res.data[0].totalTimeElapsed, 10);
            let temp = 0;
            if (totalTimeElapsed === 0) { temp = 1; }
            totalTime = [{ value: totalTimeElapsed }, { value: temp }];
        }
        // Fetch Operation Average Time data
        res = await OperationService.getOperationAvgTime(startDate, endDate, 'automation');
        if (res?.status) { avgTime = Number(res.data[0].avg); }
        // Fetch Operation Count data
        res = await OperationService.getOperationCount(startDate, endDate, 'automation');
        if (res?.status) {
            if(res.data !== null && res.data){
                let { completedCount, totalCount } = res.data[0];
                completed = completedCount ? completedCount : 0;
                total = totalCount ? totalCount : 0;
            }
        }
        // Fetch Operation Rank data
        res = await OperationService.getOperationRank(startDate, endDate, 'automation');
        if (res?.status) { rank = res.data; }
        // Available Robots -> autom count || ipaas count
        // if (pf === 'rpa') {
	    // Fetch RPA Count data
	    res = await AutomService.getAutomCount(startDate, endDate);
        if (res?.status) { count = res.data.count; }
        // } else {
        //     // Fetch Ipaas Count data
        //     res = await IpaasService.getIpaasCount(startDate, endDate);
        //     if (res?.status) { count = res.data.count; }
        // }
        // Update state value
        setState({ robotReport, totalTime, completed, avgTime, total, count, rank });
    };
    // Handle time range
    const handleClick = (e) => {
        let target = e.target;
        let value = target.value;
        for (const el of target.parentNode.childNodes) {
            el.classList.remove('db-tabactive');
        }
        target.classList.add('db-tabactive');
        if (value === 'custom') {
            custom.current.style.display = 'block';
            return;
        }
        else { custom.current.style.display = 'none'; }
        let today = new Date();
        let date = today;
        // Week is selected
        if (value === 'week') {
            date = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
        // Month is selected
        } else if (value === 'month') {
            date = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
        // Year is selected
        } else if (value === 'year') {
            date = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());
        }
        // Update state value
        fetchData(date.toISOString(), today.toISOString());
    };
    // Handle custom date filter
    const handleSubmit = (e) => {
        e.preventDefault();
        fetchData(e.target[0].value, e.target[1].value);
    }
    const handleChange = (e, i) => {
        dateRange[i] = e;
        setDateRange([...dateRange]);
    }
    return (
        <div>
            <div className="db-row">
                <div className="db-hlabel overview">{t(label+'OVERVIEW')}</div>
                <div style={{display: 'flex', flexWrap: 'wrap', position: 'relative'}}>
                    <div className="db-tabs db-page">
                        <button className="db-tabactive" value="week" onClick={handleClick}>
                            {t(label+'WEEK')}
                        </button>
                        <button value="month" onClick={handleClick}>
                            {t(label+'MONTH')}
                        </button>
                        <button value="year" onClick={handleClick}>
                            {t(label+'YEAR')}
                        </button>
                        <button value="custom" onClick={handleClick}>
                            {t(label+'CUSTOM')}
                        </button>
                    </div>
                    <form onSubmit={handleSubmit} ref={custom} className="db-page" style={{position: 'absolute', top: 35, right: 0, padding: 5, marginLeft: 5, textAlign: 'right', display: 'none'}}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <div style={{marginBottom: 5}}><DateTimePicker format={`${personalization.date_format} HH:mm`} value={dateRange[0]} onChange={(e) => { handleChange(e, 0); }}/></div>
                        <div style={{marginBottom: 5}}><DateTimePicker format={`${personalization.date_format} HH:mm`} value={dateRange[1]} onChange={(e) => { handleChange(e, 1); }}/></div>
                        <Button type="submit" style={{backgroundColor: '#6b6b6b', color: '#fff'}}>{t(label+'FILTERS')}</Button>
                    </MuiPickersUtilsProvider>
                    </form>
                </div>
            </div>
            <div className="db-row">
                <div className="db-column">
                    <div className="db-page db-mincard">
                        <div>
                            <div className="db-label">{t(label+'ROBOT-CREATED')}</div>
                            <div className="db-sublabel">({t(label+'ALL-USERS')})</div>
                        </div>
                        <h2>{state.count}</h2>
                    </div>
                    <div className="db-page">
                        <div className="db-label paddingl">{t(label+'TOTAL-TIME')}</div>
                        <PieChart width={200} height={200} style={{ margin: 'auto' }}>
                            <Pie data={state.totalTime} cx={90} cy={90} innerRadius={60} outerRadius={70} dataKey="value">
                                {state.totalTime.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={ttCOLORS[index % ttCOLORS.length]} />
                                ))}
                                <Label value={state.totalTime[0].value + ' hrs'} position="center" fill={ttCOLORS[0]}
                                    style={{fontSize: state.totalTime[0].value?.toString().length > 4 ? 23 : 28, fontWeight: 'bold'}}/>
                            </Pie>
                        </PieChart>
                        <div className="db-chartlabel">
                            <div>
                                <span style={{ color: ttCOLORS[0] }}>&#9673;</span>
                                &nbsp;Automated
                            </div>
                            <div>
                                <span style={{ color: ttCOLORS[1] }}>&#9673;</span>
                                &nbsp;Time Saved
                            </div>
                        </div>
                    </div>
                </div>
                <div className="db-column">
                    <div className="db-page db-mincard">
                        <div>
                            <div className="db-label">{t(label+'TOTAL-ROBOT-RUNS')}</div>
                            <div className="db-sublabel">({t(label+'ALL-USERS')})</div>
                        </div>
                        <h2>{state.total}</h2>
                    </div>
                    <div className="db-page">
                        <div className="db-label paddingl">{t(label+'ROBOT-REPORT')}</div>
                        <PieChart width={200} height={200} style={{ margin: 'auto' }}>
                            <Pie data={state.robotReport} cx={90} cy={90} innerRadius={60} outerRadius={70} dataKey="value">
                                {state.robotReport.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={rrCOLORS[index % rrCOLORS.length]}/>
                                ))}
                                <Label value={state.robotReport[0].value + '%'} position="center" fill={rrCOLORS[0]} style={{fontSize: 36, fontWeight: 'bold'}}/>
                            </Pie>
                        </PieChart>
                        <div className="db-chartlabel">
                            <div>
                                <span style={{ color: rrCOLORS[0] }}>&#9673;</span>
                                &nbsp;{t(label+'SUCCEEDED')}
                            </div>
                            <div>
                                <span style={{ color: rrCOLORS[1] }}>&#9673;</span>
                                &nbsp;{t(label+'FAILED')}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="db-column">
                    <div className="db-page db-mincard">
                        <div>
                            <div className="db-label">{t(label+'AVG-TIME')}</div>
                            <div className="db-sublabel">({t(label+'ALL-USERS')})</div>
                        </div>
                        <div><span style={{ fontSize: '1.5em', fontWeight: 'bold' }}>{state.avgTime}</span> <span>{t(label+'HRS')}</span></div>
                    </div>
                    <div className="db-page">
                        <div className="db-label paddingl">{t(label+'TOP-BOTS')}</div>
                        <div style={{ minWidth: 200, minHeight: 217 }}>
                            <table>
                                <tbody>
                                    {state.rank.map((item, itemI) => {
                                        return (
                                            <tr key={itemI}>
                                                <td className="db-td1"><div className="db-number">{itemI + 1}</div></td>
                                                <td className="db-td2">{item.name}</td>
                                                {item.state === 'up' ?
                                                    <td className="db-td3 up">&#8593;</td> :
                                                    item.state === 'down' ?
                                                        <td className="db-td3 down">&#8595;</td> :
                                                        <td className="db-td3 same">&#8597;</td>
                                                }
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Overview;